import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Conteudo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 18px;
`

export const ContainerLink = styled.div`
  margin-bottom: 8px;
`

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const Campo = styled.div`
  display: flex;
  flex-direction: column;

  span.rotulo {
    font-size: 12px;
    color: ${Cores.CINZA_2_CLARO};
    margin-bottom: 4px;
  }

  span.valor {
    font-size: 14px;
    color: ${Cores.CINZA_1};
    font-weight: 500;
  }
`

export const TituloBloco = styled.h4`
  margin: 28px 0 8px;
  font-size: 14px;

  &:first-of-type {
    margin-top: 20px;
  }
`

/** Breadcrumb/título à esquerda e a tag de status logo ao lado. */
export const TituloComStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

/**
 * Envolve o MenuContexto para empilhar as opções na vertical: o componente
 * compartilhado usa `display: block` e o botão de opção tem `flex: 1`, o que
 * deixa os itens lado a lado. Ajustamos só aqui, sem mexer no componente.
 */
export const ContainerAcoes = styled.div`
  /* Com abrirComClick a única classe do menu é .aberto. */
  div.aberto:not(.mc_caixa_botao) {
    display: flex;
    flex-direction: column;
    min-width: 210px;
  }

  div.aberto:not(.mc_caixa_botao) > button {
    flex: none;
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
    text-align: left;
  }
`

/** Botão que abre o menu de ações, no padrão "Secundario" dos demais. */
export const BotaoAcoes = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid ${Cores.SECUNDARIA_1};
  border-radius: 4px;
  background: transparent;
  color: ${Cores.SECUNDARIA_1};
  font-family: 'Saira-Semi-Bold', sans-serif;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;

  ::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid ${Cores.SECUNDARIA_1};
  }

  :hover {
    background: ${Cores.SECUNDARIA_1};
    color: ${Cores.BRANCO};

    ::after {
      border-top-color: ${Cores.BRANCO};
    }
  }
`

export const BadgeStatus = styled.span<{ fundo: string; corTexto: string }>`
  display: inline-block;
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  white-space: nowrap;
  background-color: ${({ fundo }) => fundo};
  color: ${({ corTexto }) => corTexto};
`

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ItemTimeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0 2px 14px;
  border-left: 2px solid ${Cores.PRIMARIA_2};

  .titulo {
    font-size: 14px;
    color: ${Cores.CINZA_1};
    font-weight: 500;
  }

  .meta {
    font-size: 11px;
    color: ${Cores.CINZA_2_CLARO};
  }

  .observacao {
    font-size: 13px;
    color: ${Cores.CINZA_2};
  }
`

export const Tabela = styled.table`
  margin: 0 0 8px 0;
  font-family: 'Saira', sans-serif;
  font-size: 12px;
  color: #191414;
  border-collapse: collapse;
  border: 1px solid ${Cores.CINZA_3_CLARO};
  width: 100%;

  th {
    background: ${Cores.CINZA_HEAD_TABLE};
    color: ${Cores.PRETO};
    font-family: 'Saira-Semi-Bold', sans-serif;
    font-weight: 600;
    font-size: 13px;
    padding: 10px 12px;
    text-transform: uppercase;
  }

  /* Cabeçalho e célula seguem o mesmo alinhamento: texto à esquerda,
     números à direita. */
  th.texto,
  td.texto {
    text-align: left;
  }

  th.numero,
  td.numero {
    text-align: right;
    white-space: nowrap;
  }

  tbody tr {
    height: 44px;
    border: 1px solid ${Cores.FUNDO};

    &.par {
      background: ${Cores.FUNDO};
    }

    td {
      padding: 0 12px;
    }
  }
`

/** Corpo dos modais desta feature. */
export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-width: 420px;
  max-width: 520px;
`

export const SemDados = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  color: ${Cores.CINZA_2};
  font-size: 14px;
`

/** Link para abrir turma/curso em outra aba. */
export const LinkExterno = styled.a`
  color: ${Cores.SECUNDARIA_1_ESCURO};
  text-decoration: none;
  font-weight: 500;

  :hover {
    text-decoration: underline;
  }

`
